const friendsAndFamily = {
  title: 'FRIENDS & FAMILY',
  color: 'text-red-600',
  items: ['Pani', 'Aleksandr', 'Hanis', 'Alyn', 'Adarsh', 'Michaela Olsen'],
};

const communitySupport = {
  title: 'ONLINE SUPPORT',
  color: 'text-orange-600',
  items: ['Don McCurdy', 'Anderson Mancini', 'Manthrax', 'Jack Huygens', 'drcmda'],
};

const inspirationAndIdeas = {
  title: 'INSPIRATION & IDEAS',
  color: 'text-yellow-400',
  items: ['Rohit Nag', 'Refokus (Cula.tech)', 'Ivan Porto', 'Rachel Wei', 'Jesse Zhou', 'ilkhoeri', 'marcelodolza'],
};

const contentCreators = {
  title: 'CONTENT CREATORS',
  color: 'text-blue-800',
  items: ['Mezaka', '5 Minutes Blender', 'Polygon Runway', "Valentin's Coding Book", 'Wawa Sensei', 'Blender Guru'],
};

const teachers = {
  title: 'TEACHERS',
  color: 'text-purple-500',
  items: ['Bruno Simon', 'Brad Woods', 'Andrew Woan', 'Josh W. Comeau'],
};

const libraryCreators = {
  title: 'LIBRARY CREATORS',
  color: 'text-sky-400',
  items: ['Mr Doob', '@0xca0a', 'Joe Martinez', 'Clariity', 'AriaMinaei'],
};

const mentors = {
  title: 'MENTORS',
  color: 'text-green-500',
  items: ['Fayang Pan', 'Dan Snell', 'Sean Peterkin', 'Tony Nelson', 'Mary Hussey', 'Ian Dalrymple'],
};


export const row1Sections = [friendsAndFamily, communitySupport, inspirationAndIdeas];
export const row2Sections = [contentCreators, teachers,  mentors , libraryCreators, ];

export const specialThanks = [
  {
    img: '/images/Contact/bruno-simon-headshot.webp',
    alt: 'Bruno Simon',
    text: `Bruno Simon's Three.js course was the single best resource that helped me overcome the biggest hurdles of this project.`,
  },
  {
    img: '/images/Contact/aleks-headshot.webp',
    alt: 'Aleksandr',
    text: `Aleksandr has been by my side throughout this entire project ,
motivating me to finish, helping me troubleshoot bugs, and offering constant emotional support. 
Thank you Sanya !`,
  },
];

export const assetAttributions = [
  'Polyperfect models',
  'SVG Repo',
  'Sketchfab',
  'Uiverse',
]; 